




































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  FraudCheckUser,
  FraudCheckQueueFilterColumn,
  BankCustodian,
  FraudCheckAdjudicationStatus,
  FraudCheckStatus,
  FraudCheckQueueFilterModel,
  FraudCheckEnrollmentType
} from "@/admin/types";

import { Location } from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import * as RouteNames from "@/admin/route-names";
import { custodianDisplayName } from "@/shared/custodianSettingsHelper";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFraudCheckStore } from "@/admin/store/fraudcheck";

@Component({
  components: {
    Button,
    Input,
    ErrorSummary
  }
})
export default class AdminUtilityFraudCheckQueue extends Vue {
  $validator: Validator;
  fraudCheckUsers: FraudCheckUser[] = [];

  notifierStore = useNotifierStore();
  fraudCheckStore = useFraudCheckStore();

  @Prop() pageNumber: number;
  searchTerm = "";

  @Prop() routeToFraudCheckList: (pageNumber: number) => Location;
  RouteNames = RouteNames;

  created (): void {
    this.loadDefaultFilterOptions();
    this.fetchFraudCheckList();
  }

  showFilters = false;
  filterCustodian: [] = [];
  filterEnrollmentType: [] = [];
  filterAdjudicationStatus = this.defaultFraudQueueAdjudicationSelectOptions;
  filterFraudCheckStatus: [] = [];
  filters: FraudCheckQueueFilterModel[] = [];

  fetchFraudCheckList (): void {
    this.fraudCheckStore.getFraudCheckList(
            { pageNumber: this.pageNumber, searchTerm: this.searchTerm, filters: this.filters })
        .catch(this.handleError);
  }

  @Watch("pageNumber")
  onRouteValuePageNumberChanged () {
    this.fetchFraudCheckList();
  }

  get isLoaded (): boolean {
    const o = this.fraudCheckStore.getFraudCheckListByPageNumber(this.pageNumber);
    if (o.isLoading === false) {
      this.fraudCheckUsers = o.items;
    }
    return !o.isLoading;
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.showError(
        (err && err.errorMessage) ||
        "Error processing your request. Please try again later"
    );
  }

  get canGoBack () {
    return this.pageNumber > 1;
  }

  get canGoForward () {
    return this.fraudCheckStore.getFraudCheckListByPageNumber(this.pageNumber).hasMore;
  }

  routeToQueueUser (id) {
    return { name: RouteNames.FraudCheckDetail, params: { queueId: id } };
  }

  get hasSearchTerm () {
    return this.searchTerm && this.searchTerm.length > 0;
  }

  onSubmit (): void {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid || this.searchTerm === "") {
            return;
          }
          const o: any = this.fraudCheckStore.getFraudCheckList(
              { pageNumber: this.pageNumber, searchTerm: this.searchTerm } as any);
          this.fraudCheckUsers = o.items;
        });
  }

  reload (): void {
    this.fraudCheckStore.clearFraudCheckList();
    this.fraudCheckStore.getFraudCheckList(
            { pageNumber: this.pageNumber, searchTerm: this.searchTerm, filters: this.filters })
        .catch(this.handleError);
  }

  onReset (): void {
    this.searchTerm = "";
    this.reload();
  }

  get custodianSelectOptions () {
    return Object.keys(BankCustodian)
        .filter(k => BankCustodian[k] !== BankCustodian.None)
        .map(k => ({ value: BankCustodian[k], text: custodianDisplayName(BankCustodian[k]) }));
  }

  get fraudQueueAdjudicationSelectOptions () {
    return Object.keys(FraudCheckAdjudicationStatus)
        .filter(k => FraudCheckAdjudicationStatus[k] !== FraudCheckAdjudicationStatus.None)
        .map(k => ({
          value: FraudCheckAdjudicationStatus[k],
          text: this.adjudicationStatusDisplay(FraudCheckAdjudicationStatus[k])
        }));
  }

  get enrollmentTypeSelectOptions () {
    return Object.keys(FraudCheckEnrollmentType)
        .filter(k => FraudCheckEnrollmentType[k] !== FraudCheckEnrollmentType.None)
        .map(k => ({ value: FraudCheckEnrollmentType[k], text: k }));
  }

  get fraudCheckStatusSelectOptions () {
    return Object.keys(FraudCheckStatus)
        .filter(k => FraudCheckStatus[k] !== FraudCheckStatus.None)
        .map(k => ({ value: FraudCheckStatus[k], text: this.fraudCheckStatusDisplay(FraudCheckStatus[k]) }));
  }

  get defaultFraudQueueAdjudicationSelectOptions () {
    return this.fraudQueueAdjudicationSelectOptions
        .filter(k => k.value === FraudCheckAdjudicationStatus.NeedsReview
            || k.value === FraudCheckAdjudicationStatus.InProcess)
        .map(k => k.value);
  }

  loadDefaultFilterOptions () {
    this.filters = [];
    this.filters.push({
      field: FraudCheckQueueFilterColumn.AdjudicationStatus,
      values: this.defaultFraudQueueAdjudicationSelectOptions
    });
  }

  onFilterApply (): void {
    this.filters = [];
    if (this.filterCustodian.length) {
      this.filters.push({ field: FraudCheckQueueFilterColumn.Custodian, values: this.filterCustodian });
    }
    if (this.filterFraudCheckStatus.length) {
      this.filters.push({ field: FraudCheckQueueFilterColumn.FraudCheckStatus, values: this.filterFraudCheckStatus });
    }
    if (this.filterAdjudicationStatus.length) {
      this.filters.push(
          { field: FraudCheckQueueFilterColumn.AdjudicationStatus, values: this.filterAdjudicationStatus });
    }
    if (this.filterEnrollmentType.length) {
      this.filters.push({ field: FraudCheckQueueFilterColumn.EnrollmentType, values: this.filterEnrollmentType });
    }
    this.reload();
  }

  onFilterClear (): void {
    this.filterCustodian = [];
    this.filterFraudCheckStatus = [];
    this.filterAdjudicationStatus = [];
    this.filterEnrollmentType = [];
    this.filters = [];
    this.reload();
  }

  onFilterToggle () {
    this.showFilters = !this.showFilters;
  }

  adjudicationStatusDisplay (k) {
    switch (k) {
      case FraudCheckAdjudicationStatus.None:
        return "None";
      case FraudCheckAdjudicationStatus.NeedsReview:
        return "Needs Review";
      case FraudCheckAdjudicationStatus.InProcess:
        return "In-Process";
      case FraudCheckAdjudicationStatus.ReviewComplete:
        return "Review Complete";
      case FraudCheckAdjudicationStatus.AutoReviewed:
        return "Auto Reviewed";
      case FraudCheckAdjudicationStatus.AwaitingDocuments:
        return "Awaiting Documents";
      case FraudCheckAdjudicationStatus.ChallengeQuestions:
        return "Unanswered Challenge Questions";
    }
  }

  custodianDisplay (k) {
    return custodianDisplayName(k);
  }

  fraudCheckStatusDisplay (k) {
    switch (k) {
      case FraudCheckStatus.None:
        return "None";
      case FraudCheckStatus.FraudCheckRequired:
        return "Fraud Check Required";
      case FraudCheckStatus.Pass:
        return "Pass";
      case FraudCheckStatus.Fail:
        return "Fail";
      case FraudCheckStatus.Error:
        return "Error";
      case FraudCheckStatus.DocumentsRequested:
        return "Documents Requested";
      case FraudCheckStatus.FraudCheckNotRequired:
        return "No Fraud Check Required";
    }
  }
}
